import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Plus, Trash2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { OVERLINE, H1, Panel, useAdmin } from "@/components/admin/ui";

const inp = "flex-1 border border-[#E5E2DC] bg-white px-3 py-2 text-sm outline-none focus:border-[#1F2A22]";

export default function AdminCommerceCategories() {
  const { admin } = useAdmin();
  const canEdit = admin?.permissions?.includes("marketplace");
  const navigate = useNavigate();
  const [cats, setCats] = useState(null);
  const [cols, setCols] = useState(null);
  const [newCat, setNewCat] = useState({ name: "", icon: "tag" });
  const [newCol, setNewCol] = useState("");

  const load = () => {
    api.admCategories().then(setCats).catch(() => setCats([]));
    api.admCollections().then(setCols).catch(() => setCols([]));
  };
  useEffect(load, []);

  const addCat = async () => { if (!newCat.name.trim()) return; try { await api.admCategoryCreate(newCat); setNewCat({ name: "", icon: "tag" }); load(); } catch { toast.error("Failed"); } };
  const delCat = async (c) => { if (!window.confirm(`Delete "${c.name}"? Products keep, just uncategorized.`)) return; try { await api.admCategoryDelete(c.id); load(); } catch { toast.error("Failed"); } };
  const addCol = async () => { if (!newCol.trim()) return; try { await api.admCollectionCreate({ name: newCol }); setNewCol(""); load(); } catch { toast.error("Failed"); } };
  const delCol = async (c) => { if (!window.confirm(`Delete collection "${c.name}"?`)) return; try { await api.admCollectionDelete(c.id); load(); } catch { toast.error("Failed"); } };

  return (
    <div className="p-6 md:p-8 max-w-3xl" data-testid="admin-commerce-categories">
      <button onClick={() => navigate("/admin/commerce/products")} className="inline-flex items-center gap-1.5 text-sm text-[#5C6B61] mb-3"><ArrowLeft size={16} /> Products</button>
      <div><span className={OVERLINE}>Commerce</span><h1 className={`${H1} mt-1`}>Categories & Collections</h1></div>

      <div className="grid md:grid-cols-2 gap-6 mt-6">
        <Panel title="Categories">
          {cats === null ? <Loader2 className="animate-spin text-[#FF6A00]" /> : (
            <div className="space-y-2 mb-3" data-testid="cats-list">
              {cats.map((c) => (
                <div key={c.id} className="flex items-center justify-between border border-[#E5E2DC] px-3 py-2" data-testid={`cat-${c.id}`}>
                  <span className="text-sm text-[#1F2A22]">{c.name} <span className="text-xs text-[#8A8478]">· {c.icon}</span></span>
                  {canEdit && <button onClick={() => delCat(c)} className="text-red-600"><Trash2 size={14} /></button>}
                </div>
              ))}
            </div>
          )}
          {canEdit && (
            <div className="flex gap-2">
              <input className={inp} placeholder="Category name" value={newCat.name} onChange={(e) => setNewCat({ ...newCat, name: e.target.value })} data-testid="cat-name" />
              <input className="w-24 border border-[#E5E2DC] px-2 py-2 text-sm" placeholder="icon" value={newCat.icon} onChange={(e) => setNewCat({ ...newCat, icon: e.target.value })} />
              <button onClick={addCat} className="bg-[#FF6A00] text-white px-3" data-testid="cat-add"><Plus size={16} /></button>
            </div>
          )}
          <p className="text-[11px] text-[#8A8478] mt-2">Icons use lucide-react names (e.g. shirt, cup-soda, tent, baby).</p>
        </Panel>

        <Panel title="Collections">
          {cols === null ? <Loader2 className="animate-spin text-[#FF6A00]" /> : (
            <div className="space-y-2 mb-3" data-testid="cols-list">
              {cols.length === 0 && <p className="text-sm text-[#8A8478]">No collections yet.</p>}
              {cols.map((c) => (
                <div key={c.id} className="flex items-center justify-between border border-[#E5E2DC] px-3 py-2">
                  <span className="text-sm text-[#1F2A22]">{c.name}</span>
                  {canEdit && <button onClick={() => delCol(c)} className="text-red-600"><Trash2 size={14} /></button>}
                </div>
              ))}
            </div>
          )}
          {canEdit && (
            <div className="flex gap-2">
              <input className={inp} placeholder="Collection name" value={newCol} onChange={(e) => setNewCol(e.target.value)} data-testid="col-name" />
              <button onClick={addCol} className="bg-[#FF6A00] text-white px-3" data-testid="col-add"><Plus size={16} /></button>
            </div>
          )}
        </Panel>
      </div>
    </div>
  );
}
